import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vtrsgpmkg: FaireProductEntity = {
  token: "p_7vtrsgpmkg",
  type: "product",
  name: "D2997   PATTERNED RIB KNITTED LONG DRESS",
  brandToken: "b_4bdmvim3s7",
  brandName: "MIOU MUSE",
  imageUrl:
    "https://cdn.faire.com/fastly/bde97382a7675e2bd88708d8a4df48050faf66316acbe638d8dbd80409321adc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/378cf254bd2860a0641a954a0d4f5f6bf7e9ec868dfbab18bc8aef7a10bd68a1.jpeg",
    "https://cdn.faire.com/fastly/694b59e7ad6af274800b6df3ae7a21cb875ac7f4204d56a8508a31932968cb75.jpeg",
    "https://cdn.faire.com/fastly/252face9b3fa369d09d545e13c9701a45995f6f68801bb9a605817382de02c66.jpeg",
    "https://cdn.faire.com/fastly/088af033ebe94e3733e784240ab8604a44242482b4447056e416c5c3be56d087.jpeg",
    "https://cdn.faire.com/fastly/560be565064d828dec382e95a271a21b67bd94b8572db4f78012c3fc412aaf44.jpeg",
    "https://cdn.faire.com/fastly/139db3b84a9ca59c1382bbe0ef39b62b0c9b3fb34ede7b02e91907dcad66e8fd.jpeg",
    "https://cdn.faire.com/fastly/5fdd8892b17c99e2bed3b04d2adcf4d0ecc253d1a81f424a2e08525f17de0ba7.jpeg",
    "https://cdn.faire.com/fastly/f0cd8daf94faf7609ddd3bf02bec6e19b0fe2899015becd9b7d2ddefd2514618.jpeg",
    "https://cdn.faire.com/fastly/c5d7adbd412be33d7413472fbfe26ab43946f2909f571788dca386428b6ea880.jpeg",
    "https://cdn.faire.com/fastly/dc6d8f9017addf960806eb1ad96561c7123606dd3b1d88ef66f8665cae97cc84.jpeg",
    "https://cdn.faire.com/fastly/b362fe3e493482d2e073857c18f6ebe49935a7409489793e5060aaa95afb3dca.jpeg",
    "https://cdn.faire.com/fastly/9e676ad06d5be6094fb1a2b323d9eacb44a20d008a6b056e14e5bb45fd9869e4.jpeg",
    "https://cdn.faire.com/fastly/30329fae7fc9db4bbd1b82d76e4a35269dd841ece628dc78a89a7c63cf11db94.jpeg",
    "https://cdn.faire.com/fastly/a313c99f6b224442a79ae75635a010c9de8e5a36c8a9545b0fd05f25883ee9ad.jpeg",
    "https://cdn.faire.com/fastly/9ca6368ba2f07cffee24334c4c87e89b1dc68700d125fb7e4c99c55abf9f430c.jpeg",
    "https://cdn.faire.com/fastly/3f65f19b6fc406c38d4cfc93e3de295e285913133d1c4fde019c46d9a28fcbbf.jpeg",
    "https://cdn.faire.com/fastly/a2cff6b6c43d0f8517f7c6c7eb59ee71f99a9278ab54006beb92d5e56710b6d5.jpeg",
    "https://cdn.faire.com/fastly/e159b3000491e9a37587a9c63c992338c434e902dd9955174ca1281e00d8c0c8.jpeg",
    "https://cdn.faire.com/fastly/8d355a37380d3044a39012b07f719dd567a952b5ca8b222c8abb22b43628b6a7.jpeg",
  ],
  priceDollars: 166.5,
  description:
    "Patterned Rib Knitted Long Dress\n\n𝗦𝗶𝘇𝗲 & 𝗙𝗶𝘁\n• Model is wearing size S\n• Measurements taken from size S\n• Height - 5' 7 1/2\" / 175.3CM",
  tags: [],
  msrpDollars: 333,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:05.246Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
